"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function PlayStartInCircleIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "m12,23.342C5.746,23.342.659,18.254.659,12S5.746.658,12,.658s11.342,5.088,11.342,11.342-5.088,11.342-11.342,11.342Zm0-20.984C6.683,2.358,2.358,6.683,2.358,12s4.325,9.642,9.642,9.642,9.643-4.325,9.643-9.642S17.316,2.358,12,2.358Z" }),
        react_1.default.createElement("path", { d: "m9.653,18.765c-.194,0-.39-.043-.575-.13-.473-.224-.767-.688-.767-1.211V6.576c0-.523.294-.987.767-1.211.476-.222,1.018-.155,1.422.177l6.595,5.424c.311.255.488.632.488,1.033s-.178.779-.488,1.034l-6.595,5.424c-.246.203-.544.307-.847.307Zm.357-11.424v9.318l5.664-4.659-5.664-4.659Z" })));
}
exports.default = PlayStartInCircleIcon;
